module.exports = __webpack_public_path__ + "e8a45faaa44da8b22c77e28255fe90c7.svg";